import * as Yup from 'yup';

const schema = Yup.object().shape({
  nome: Yup.string().required('Valor requerido'),
  min_valor: Yup.number().required('Valor requerido'),
  max_valor: Yup.number().required('Valor requerido'),
});

export default schema;
